import { resourceState, resourceMutations } from '@/store/utils/resource';
import { ORDERS } from '@/store/entities/schema_types';
import { salesOrdersClient as service } from '@/api/clients';

export default {
  namespaced: true,
  state: resourceState(),
  getters: {
    salesOrders({ ids }, getters, { entities }) {
      return ids.map((id) => entities.orders.byId[id]);
    },
  },
  mutations: resourceMutations,
  actions: {
    async load(ctx, { params = {} }) {
      try {
        const response = await service.list({ params });
        const { data, meta, links } = response.data;
        const salesOrderUuids = await ctx.dispatch('persist', { type: ORDERS, data });
        ctx.commit('setIds', salesOrderUuids);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);
        return Promise.resolve({
          salesOrderUuids,
          meta,
          links,
        });
      } catch (error) {
        const { response } = error;
        return Promise.reject(response);
      }
    },

    persist(ctx, { type, data }) {
      return ctx.dispatch(
        'entities/persistEntities',
        {
          type,
          data,
        },
        { root: true }
      );
    },
  },
};
